export default __webpack_public_path__ + "static/media/casinoroo.ca7769e0.png";